<template>
    <nav class="sticky top-0 z-50 bg-black/95 backdrop-blur-xl border-b border-white/10">
        <div class="max-w-[1400px] mx-auto px-4 sm:px-6 py-3">
            <div class="flex items-center justify-between gap-3">
                <!-- Left: Logo - Star on Mobile, Full on Desktop -->
                <a href="/" class="flex-shrink-0">
                    <!-- Mobile: Star Icon only (matches sidebar) -->
                    <img
                        src="https://sm.naughtycdn.com/images/landers/prize/NA-Star.png"
                        alt="Naughty America"
                        class="h-8 w-8 sm:hidden"
                    />

                    <!-- Desktop: Full Logo + Tagline -->
                    <div class="hidden sm:block">
                        <img
                            src="https://sm.naughtycdn.com/images/www/naughty-america-logo.png"
                            alt="Naughty America"
                            class="h-6"
                        />
                        <p class="text-white/50 text-xs mt-1 tracking-wide">
                            14k+ Videos • Monthly Stars Included
                        </p>
                    </div>
                </a>

                <!-- Right: Navigation Buttons -->
                <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                    <Link
                        :href="getMainAuditionsUrl(isUserLoggedIn, routePrefix)"
                        @click="trackFathomEvent('Top Menu Auditions Button Clicked')"
                        class="px-3 sm:px-4 py-2 rounded-lg bg-blue-600/10 border border-blue-500/50 text-blue-400 text-xs font-semibold transition-all whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        Auditions
                    </Link>

                    <a
                        v-if="!requiresAgeVerification && !hide.videos"
                        :href="isUserLoggedIn ? route('members2.main.home') : route('www.main.home')"
                        class="px-3 sm:px-4 py-2 rounded-lg bg-white/10 hover:bg-white/15 border border-white/10 text-white text-xs font-semibold transition-all active:scale-95 whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        <span class="hidden sm:inline">14k+ Videos</span>
                        <span class="sm:hidden">Videos</span>
                    </a>

                    <button
                        v-if="!isUserLoggedIn && !hide.getStars"
                        @click="$emit('joinClick')"
                        class="hidden sm:flex px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold transition-all active:scale-95 whitespace-nowrap min-h-[44px] items-center uppercase tracking-wide"
                    >
                        Get Stars
                    </button>

                    <button
                        v-if="!isUserLoggedIn && !hide.join"
                        @click="$emit('joinClick')"
                        class="hidden sm:flex px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold transition-all active:scale-95 whitespace-nowrap min-h-[44px] items-center uppercase tracking-wide"
                    >
                        Join Free
                    </button>

                    <a
                        v-if="!isUserLoggedIn && !hide.signIn"
                        :href="route('members2.auth.login', { dest: currentUrl })"
                        class="px-3 sm:px-4 py-2 rounded-lg bg-white/10 hover:bg-white/15 border border-white/10 text-white text-xs font-semibold transition-all active:scale-95 whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        Sign In
                    </a>

                    <KebabMenu
                        v-if="!hide.kebab"
                        :isUserLoggedIn="isUserLoggedIn"
                        :isGoldUser="isGoldUser"
                        :starBalance="walletBalance"
                        variant="default"
                        :routePrefix="routePrefix"
                        :requiresAgeVerification="requiresAgeVerification"
                        @joinClick="$emit('joinClick')"
                        @goldJoinClick="$emit('goldJoinClick')"
                        @update:open="$emit('update:kebabOpen', $event)"
                    />
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup>
import KebabMenu from "@/Components/Reels/KebabMenu.vue";
import {Link, usePage} from "@inertiajs/vue3";
import {getMainAuditionsUrl} from "@/Helpers/auditions";
import {computed, ref} from "vue";
import {trackFathomEvent} from "@/Helpers/analytics";

defineProps({
    isUserLoggedIn: {
        type: Boolean,
        required: true
    },
    isGoldUser: {
        type: Boolean,
        required: true
    },
    routePrefix: {
        type: String
    },
    requiresAgeVerification: {
        type: Boolean,
        required: true
    },
    // Pass an object to selectively hide header elements.
    // Recognised keys: videos | getStars | kebab, join, signIn
    // Example: :hide="{ videos: true, kebab: true }"
    hide: {
        type: Object,
        default: () => ({
            videos: false,
            getStars: false,
            kebab: false,
            join: true,
            signIn: true,
        })
    }
})

const emit = defineEmits([
    'joinClick',
    'update:kebabOpen',
    'goldJoinClick'
])

const { props } = usePage();

const walletBalance = ref(Number(props.auth?.user?.wallet_balance) || 0)

const currentUrl = computed(() => {
    if (typeof window !== 'undefined' && window.location) {
        return window.location.pathname + window.location.search
    }
    return ''
})
</script>
